export const actionTypePrefix = '@@POLLS';

//# sourceMappingURL=constants.js.map